import { render, staticRenderFns } from "./ChecklistVersionSelector.vue?vue&type=template&id=64ac3d06&scoped=true"
import script from "./ChecklistVersionSelector.vue?vue&type=script&lang=js"
export * from "./ChecklistVersionSelector.vue?vue&type=script&lang=js"
import style0 from "./ChecklistVersionSelector.vue?vue&type=style&index=0&id=64ac3d06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ac3d06",
  null
  
)

export default component.exports